import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AllPosts } from "../types/posts";

/**
 * An in-flight post shown in the floating "Processing" panel on My Schedule.
 * Shape mirrors `AllPosts` exactly so the panel can hand the entry straight
 * to `<PostCard post={...} />` with zero adapter logic — the floating tile
 * looks identical to the calendar tiles.
 */
export type ProcessingPost = AllPosts;

interface ProcessingPostsState {
    list: ProcessingPost[];
}

const initialState: ProcessingPostsState = {
    list: [],
};

const processingPostsSlice = createSlice({
    name: "processingPosts",
    initialState,
    reducers: {
        addProcessingPost(state, action: PayloadAction<ProcessingPost>) {
            state.list.unshift(action.payload);
        },
        removeProcessingPost(state, action: PayloadAction<string>) {
            state.list = state.list.filter((p) => p.id !== action.payload);
        },
        clearProcessingPosts(state) {
            state.list = [];
        },
        // Replace the entire list — used when My Schedule refreshes its posts
        // feed and derives the processing subset from the server response.
        setProcessingPosts(state, action: PayloadAction<ProcessingPost[]>) {
            state.list = action.payload;
        },
    },
});

export const {
    addProcessingPost,
    removeProcessingPost,
    clearProcessingPosts,
    setProcessingPosts,
} = processingPostsSlice.actions;
export default processingPostsSlice.reducer;
